import { useEffect, useRef, useState } from 'react';
import * as LancamentosAPI from '../../../../../api/lancamentos';

export function useComprovantesModule({ uuid, open, setFlashMessage, onSuccess }) {
    const [dados, setDados] = useState({});
    const [itens, setItens] = useState([]);
    const [preview, setPreview] = useState([]);

    const [novoComprovante, setNovoComprovante] = useState({
        uuid: null,
        lancamentoId: null,
        arquivo: null,
        ativo: true,
        funcao: 'Adicionar',
    });

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [comprovantePendenteDelete, setComprovantePendenteDelete] = useState(null);

    const inputFileRef = useRef(null);

    const fetchData = async () => {
        if (!uuid || !open) {
            setDados({});
            setItens([]);
            return;
        }

        setIsLoading(true);

        try {
            const response = await LancamentosAPI.listarComprovantes(
                0,
                200,
                JSON.stringify([]),
                JSON.stringify([]),
                '',
                JSON.stringify([]),
                uuid
            );

            const registro = response?.data?.data?.[0] || {};
            setDados(registro);
            setItens(registro?.lancamentoComprovantes || []);

            setNovoComprovante((prev) => ({
                ...prev,
                lancamentoId: registro?.id || null,
            }));
        } catch (error) {
            console.error(error);
            setDados({});
            setItens([]);
            setFlashMessage?.(
                error?.response?.data?.message || 'Erro ao carregar comprovantes.',
                error?.response?.data?.type || 'error'
            );
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [uuid, open]);

    const limparComprovante = () => {
        setNovoComprovante((prev) => ({
            uuid: null,
            lancamentoId: dados?.id || null,
            arquivo: null,
            ativo: true,
            funcao: 'Adicionar',
        }));

        setPreview([]);

        if (inputFileRef.current) {
            inputFileRef.current.value = '';
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        const lista = Array.from(files || []);

        setPreview(lista);
        setNovoComprovante((prev) => ({
            ...prev,
            [name.split('.')[1]]: lista,
        }));
    };

    const handleChange = (e) => {
        const { name, checked, value, type } = e.target;

        if (name === 'ativo') {
            setNovoComprovante((prev) => ({
                ...prev,
                ativo: type === 'checkbox' ? checked : value,
            }));
            return;
        }

        setDados((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSalvar = async () => {
        if (isSubmitting) return;

        setIsSubmitting(true);

        try {
            const response = await LancamentosAPI.createOrEditComprovante(novoComprovante);

            setFlashMessage(response?.data?.message || 'Comprovante processado com sucesso.', response?.data?.type || 'success');

            limparComprovante();
            await fetchData();

            if (onSuccess) onSuccess();
        } catch (error) {
            console.error(error);
            setFlashMessage(
                error?.response?.data?.message || 'Erro ao processar comprovante.',
                error?.response?.data?.type || 'error'
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    const handlePrepararExclusao = (row) => {
        setComprovantePendenteDelete({
            ...row,
            funcao: 'Deletar',
        });
        setOpenConfirmDelete(true);
    };

    const handleCloseDelete = () => {
        setOpenConfirmDelete(false);
        setComprovantePendenteDelete(null);
    };

    const handleConfirmDelete = async () => {
        if (!comprovantePendenteDelete || isSubmitting) {
            setOpenConfirmDelete(false);
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await LancamentosAPI.createOrEditComprovante(comprovantePendenteDelete);

            setFlashMessage(response?.data?.message || 'Comprovante excluído com sucesso.', response?.data?.type || 'success');

            setOpenConfirmDelete(false);
            setComprovantePendenteDelete(null);

            await fetchData();

            if (onSuccess) onSuccess();
        } catch (error) {
            console.error(error);
            setFlashMessage(
                error?.response?.data?.message || 'Erro ao excluir comprovante.',
                error?.response?.data?.type || 'error'
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    return {
        dados,
        itens,
        preview,
        novoComprovante,
        inputFileRef,

        isLoading,
        isSubmitting,
        openConfirmDelete,

        setOpenConfirmDelete,

        handleFileChange,
        handleChange,
        handleSalvar,
        handlePrepararExclusao,
        handleConfirmDelete,
        handleCloseDelete,
        limparComprovante,
        fetchData,
    };
}
